
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { Point } from '../../shared/contracts/AnswerContract';
import { NewAnswerModel } from '../../views/questionnaires/QuestionnaireModel';

@Component
export default class Question extends Vue {
    @Prop() answer: NewAnswerModel;
    @Prop() questionText: string;

    public answerCopy: NewAnswerModel = null;

    @Emit('answerChanged')
    @Watch('answerCopy', { deep: true })
    onAnswerChanged(val: NewAnswerModel) {}

    private quantitativeOptions: { text: string; value: Point }[] = [];

    public getQuantitativeAnswerLabel(answer: Point): string {
        let label = this.quantitativeOptions.find(v => v.value === answer);
        return label && label.text;
    }

    created() {
        this.answerCopy = new NewAnswerModel(this.answer.id, this.answer.answerType, this.answer.quantitative);
        this.quantitativeOptions = [
            {
                text: 'Sure!',
                value: Point.Positive
            },
            {
                text: 'So, so...',
                value: Point.Neutral
            },
            {
                text: 'Not at all',
                value: Point.Negative
            }
        ];
    }

    isCommentRequired(): boolean {
        return this.answerCopy.quantitative === Point.Neutral || this.answerCopy.quantitative === Point.Negative;
    }
}
